import { LinearProgress } from '@mui/material';


export function LoadingScreen() {
  return (
    <LinearProgress sx={{ width: '100%' }} />
  );
}
